// extracted by mini-css-extract-plugin
module.exports = {"container":"i_AZ","component":"i_Aa","headline":"i_Ab","title":"i_Ac","subtitle":"i_Ad","image":"i_Ae","body":"i_Af","column":"i_Ag"};